import { Spinner } from "@hightouch/htui";

import { useTransformedSyncRunConfigurationQuery } from "src/graphql";
import { Configuration } from "src/pages/syncs/sync/run/configuration";
import { usePartnerSyncRunOutletContext } from "./outlet";

export const SyncRunConfiguration = () => {
  const { sync, syncRequest } = usePartnerSyncRunOutletContext();

  const syncId = sync.id;
  const runId = syncRequest.id;
  const model = sync?.segment;
  const destination = sync?.destination;

  const { data: prevConfig, isLoading } =
    useTransformedSyncRunConfigurationQuery(
      { id: syncId ?? "", runId: runId ?? "" },
      {
        enabled: Boolean(runId && syncId),
        select: (data) => data.getTransformedSyncRunConfiguration,
      },
    );

  if (isLoading) {
    return <Spinner size="lg" m="auto" />;
  }

  return (
    <Configuration
      destination={destination}
      model={model}
      prevConfig={prevConfig}
      prevConfigDate={syncRequest?.created_at}
      sync={sync}
    />
  );
};
